// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "6b632cecd312fcce7f7ccff4c9c43ceda48c77ec/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};